import React from 'react';

const OnboardingHeader = () => {
  return (
    <div className="text-center mb-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-2">Welcome to Nexi Dashboard</h1>
      <p className="text-gray-600">Let's get you set up with your WhatsApp Business Account</p>
    </div>
  );
};

export default OnboardingHeader;
